import { Purchase } from "./purchase.model";

export class FindPurchase {
  idCompany?: number;
  nif?: string;
  nDocument?: string;
  key?: string;
  purchases?: Purchase[];
}
